module.exports = "<app-1097-co *ngIf=\"current_role.toLowerCase().trim()==='co'\" (beneficiarySelected)=\"selectBeneficiary($event)\" (submitBtnCheck)=\"checkSubmitBtnStatus($event)\" (everwellBeneficiarySelected)=\"selectEverwellBeneficiary($event)\" [current_language]=\"currentlanguage\"></app-1097-co>\r\n<app-1097-supervisor *ngIf=\"current_role.toLowerCase().trim()==='supervisor'\"></app-1097-supervisor>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/1097/1097.component.html
// module id = ../../../../../src/app/1097/1097.component.html
// module chunks = 0